<template>
    <div >
<!-- Generator: Adobe Illustrator 25.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg class="logo" version="1.1" id="Layer_1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 56.69 56.69" style="enable-background:new 0 0 56.69 56.69;" xml:space="preserve">

<g>
	<path class="st0" d="M41.07,25.15c-1.76-6.94-8.83-11.15-15.78-9.4c-4.87,1.23-8.5,5.35-9.51,10.28c-0.67,3.28-0.02,6.13,1.31,8.56
		l0.05,0.11c0,0.01,0,0.01,0,0.01l0.02,0c1.1,1.96,2.69,3.62,4.67,4.8c0.18,0.11,0.35,0.2,0.53,0.3c2.94,1.57,6.27,1.89,9.3,1.12
		c3.04-0.77,5.81-2.64,7.65-5.43c-2.95-1.58-6.27-1.9-9.32-1.13c-1.54,0.39-3.23,0.19-4.71-0.68c-0.38-0.23-0.72-0.49-1.04-0.78
		l14.36-3.65C40.44,28.81,41.53,26.96,41.07,25.15L41.07,25.15z"/>
	<path class="st1" d="M35.43,24.84c-1.19-0.92-4.26-3.58-4.16-4.83l0.01-0.16l-0.16,0.01c-1.27,0.11-3.49,0.56-4.97,2.29
		c-0.94-0.94-1.34-1.67-1.35-1.68l-0.19-0.35l-0.26,1.55l0.03,0.05c0,0.01,0.15,0.21,0.43,0.53c-2.24-0.71-4.68-0.05-4.8-0.01
		l-0.39,0.11L20,22.5c0.16,0.07,0.32,0.14,0.47,0.22l-0.95,0.04L19.96,23c0.04,0.02,3.8,2.15,4.33,6.13l0.04,0.28l0.19-0.2
		c0.02-0.02,2.14-2.14,6.12-1.78c0.33,0.76,0.71,1.36,0.8,2.04l0.02,0.02c0-0.05,0.48-0.13,0.14-1.46c-0.08-0.33-0.18-0.65-0.3-0.95
		c0.43-1.07,1.39-1.18,2.33-1.28c0.76-0.09,1.48-0.17,1.82-0.77l0.06-0.11L35.43,24.84z M20.49,22.41c0.86-0.17,2.96-0.47,4.74,0.29
		c0.65,0.68,1.66,1.58,2.93,2.21c0.94,0.47,1.63,1.17,2.13,1.93c-3.08-0.52-4.85,0.58-5.35,0.96c-0.29-0.71-1.48-3.33-3.56-4.84
		c-0.13-0.09-0.25-0.18-0.39-0.26C20.83,22.59,20.66,22.5,20.49,22.41z M24.52,28.84c-0.34-2.03-1.49-3.55-2.41-4.48
		c-0.64-0.65-1.26-1.11-1.64-1.36l0.44-0.02c2.5,1.62,3.82,5.06,3.84,5.1l0.07,0.19l0.15-0.14c0.02-0.02,1.8-1.6,5.29-1.01
		C27.04,26.95,25.11,28.33,24.52,28.84z M31.45,28.62c-0.14-0.42-0.32-0.85-0.55-1.29c-0.02-0.03-0.04-0.07-0.05-0.1
		c-0.01-0.02-0.03-0.05-0.04-0.07c-0.05-0.08-0.1-0.17-0.15-0.25c-0.54-0.88-1.3-1.7-2.38-2.25c-0.97-0.49-1.78-1.12-2.39-1.7
		c-0.19-0.18-0.36-0.35-0.51-0.5c-0.4-0.42-0.65-0.75-0.74-0.87l0.12-0.68c0.21,0.32,0.6,0.85,1.21,1.46
		c0.06,0.06,0.13,0.13,0.2,0.19c0.65,0.62,1.53,1.3,2.66,1.93c1.07,0.59,1.73,1.52,2.13,2.48c0.04,0.11,0.09,0.21,0.13,0.32
		C31.26,27.75,31.37,28.2,31.45,28.62z M33.61,25.51c-0.9,0.1-1.92,0.22-2.45,1.22c-0.5-1.12-1.25-1.96-2.2-2.48
		c-1.11-0.61-1.98-1.29-2.62-1.9c1.37-1.61,3.4-2.07,4.65-2.19c0.12,1.58,3.51,4.31,4.16,4.83C34.85,25.37,34.27,25.44,33.61,25.51z
		"/>
	<path class="st2" d="M35.16,24.98c-0.3,0.39-0.89,0.45-1.55,0.53c-0.9,0.1-1.92,0.22-2.45,1.22c-0.5-1.12-1.25-1.96-2.2-2.48
		c-1.11-0.61-1.98-1.29-2.62-1.9c1.37-1.61,3.4-2.07,4.65-2.19C31.12,21.73,34.5,24.47,35.16,24.98z"/>
	<path class="st2" d="M30.29,26.84c-3.08-0.52-4.85,0.58-5.35,0.96c-0.29-0.71-1.48-3.33-3.56-4.84c-0.13-0.09-0.25-0.18-0.39-0.26
		c-0.16-0.1-0.33-0.2-0.5-0.28c0.86-0.17,2.96-0.47,4.74,0.29c0.65,0.68,1.66,1.58,2.93,2.21C29.1,25.38,29.79,26.08,30.29,26.84z"
		/>
	<path class="st2" d="M30.26,27.12c-3.22-0.17-5.15,1.21-5.74,1.72c-0.34-2.03-1.49-3.55-2.41-4.48c-0.64-0.65-1.26-1.11-1.64-1.36
		l0.44-0.02c2.5,1.62,3.82,5.06,3.84,5.1l0.07,0.19l0.15-0.14C24.99,28.12,26.77,26.53,30.26,27.12z"/>
	<path d="M35.43,24.84c-1.19-0.92-4.26-3.58-4.16-4.83l0.01-0.16l-0.16,0.01c-1.27,0.11-3.49,0.56-4.97,2.29
		c-0.94-0.94-1.34-1.67-1.35-1.68l-0.19-0.35l-0.26,1.55l0.03,0.05c0,0.01,0.15,0.21,0.43,0.53c-2.24-0.71-4.68-0.05-4.8-0.01
		l-0.39,0.11L20,22.5c0.16,0.07,0.32,0.14,0.47,0.22l-0.95,0.04L19.96,23c0.04,0.02,3.8,2.15,4.33,6.13l0.04,0.28l0.19-0.2
		c0.02-0.02,2.14-2.14,6.12-1.78c0.63,1.18,1.3,1.93,0.97,0.6c-0.08-0.33-0.18-0.65-0.3-0.95c0.43-1.07,1.39-1.18,2.33-1.28
		c0.76-0.09,1.48-0.17,1.82-0.77l0.06-0.11L35.43,24.84z M20.49,22.41c0.86-0.17,2.96-0.47,4.74,0.29c0.65,0.68,1.66,1.58,2.93,2.21
		c0.94,0.47,1.63,1.17,2.13,1.93c-3.08-0.52-4.85,0.58-5.35,0.96c-0.29-0.71-1.48-3.33-3.56-4.84c-0.13-0.09-0.25-0.18-0.39-0.26
		C20.83,22.59,20.66,22.5,20.49,22.41z M24.52,28.84c-0.34-2.03-1.49-3.55-2.41-4.48c-0.64-0.65-1.26-1.11-1.64-1.36l0.44-0.02
		c2.5,1.62,3.82,5.06,3.84,5.1l0.07,0.19l0.15-0.14c0.02-0.02,1.8-1.6,5.29-1.01C27.04,26.95,25.11,28.33,24.52,28.84z M31.45,28.62
		c-0.14-0.42-0.32-0.85-0.55-1.29c-0.02-0.03-0.04-0.07-0.05-0.1c-0.01-0.02-0.03-0.05-0.04-0.07c-0.05-0.08-0.1-0.17-0.15-0.25
		c-0.54-0.88-1.3-1.7-2.38-2.25c-0.97-0.49-1.78-1.12-2.39-1.7c-0.19-0.18-0.36-0.35-0.51-0.5c-0.4-0.42-0.65-0.75-0.74-0.87
		l0.12-0.68c0.21,0.32,0.6,0.85,1.21,1.46c0.06,0.06,0.13,0.13,0.2,0.19c0.65,0.62,1.53,1.3,2.66,1.93
		c1.07,0.59,1.73,1.52,2.13,2.48c0.04,0.11,0.09,0.21,0.13,0.32C31.26,27.75,31.37,28.2,31.45,28.62z M33.61,25.51
		c-0.9,0.1-1.92,0.22-2.45,1.22c-0.5-1.12-1.25-1.96-2.2-2.48c-1.11-0.61-1.98-1.29-2.62-1.9c1.37-1.61,3.4-2.07,4.65-2.19
		c0.12,1.58,3.51,4.31,4.16,4.83C34.85,25.37,34.27,25.44,33.61,25.51z"/>
	<path class="st3" d="M31.45,28.62c-0.14-0.42-0.32-0.85-0.55-1.29c-0.02-0.03-0.04-0.07-0.05-0.1c-0.01-0.02-0.03-0.05-0.04-0.07
		c-0.05-0.08-0.1-0.17-0.15-0.25c-0.54-0.88-1.3-1.7-2.38-2.25c-0.97-0.49-1.78-1.12-2.39-1.7c-0.19-0.18-0.36-0.35-0.51-0.5
		c-0.4-0.42-0.65-0.75-0.74-0.87l0.12-0.68c0.21,0.32,0.6,0.85,1.21,1.46c0.06,0.06,0.13,0.13,0.2,0.19
		c0.65,0.62,1.53,1.3,2.66,1.93c1.07,0.59,1.73,1.52,2.13,2.48c0.04,0.11,0.09,0.21,0.13,0.32C31.26,27.75,31.37,28.2,31.45,28.62z"
		/>
</g>
</svg>
    </div>

</template>
<script>
export default {
    
  
}
</script>
<style scoped>
.st0{fill:#FFFFFF;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st1{stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st2{fill:#FFFFFF;}
	.st3{fill:#CD2028;}

    .logo{
        width: 50px;
    }
</style>